import React from 'react';
import { StyledLinearProgress } from '@components/loading.styles';

interface LoadingProps {
  loading: boolean;
  bottom?: boolean;
}

export const Loading = ({ loading, bottom }: LoadingProps) => {
  return <StyledLinearProgress $loading={loading} $bottom={bottom} variant={loading ? 'indeterminate' : 'determinate'} value={0} />;
};
